import { useEffect } from "react";

export function useEmailPopup(showPopup) {
    useEffect(() => {
        // Calling existing data from the browser
        const lastShown = localStorage.getItem("emailPopupLastShown");
        const signedUp = localStorage.getItem("emailPopupSignedUp");
        
        // debug purpose
        // console.log("[EmailPopup] lastShown:", lastShown);
        // console.log("[EmailPopup] signedUp:", signedUp);

        // Already signed then skip
        if (signedUp) return;

        // Setting up the 7 days cooldown period when the customer close the signup popup without subscribing
        const now = Date.now();
        const cooldown = 7 * 24 * 60 * 60 * 1000;
        
        // debugging purpose. set this to false once done debugging
        const ignoreCooldown = false;

        // Check the cooldown time
        if (!ignoreCooldown && lastShown && now - lastShown < cooldown) {
            // console.log("[EmailPopup] Cooldown active. Skipping popup.");
            return;
        }

        let timer;

        // Customer explore the website to 50% of the website then countdown 5-15 seconds, then shows the popup message
        function onScroll() {
            const scrolled = window.scrollY + window.innerHeight;
            const docHeight = document.body.offsetHeight;
            const scrollRatio = scrolled / docHeight;

            if (scrollRatio > 0.3) {
                window.removeEventListener("scroll", onScroll);
                
                // Random delay. only used for production
                // const delay = Math.floor(Math.random() * (15000 - 5000 + 1)) + 5000;
                const delay = 2000; // 2s fixed delay for testing
                // console.log(`[EmailPopup] Waiting ${delay / 1000}s before showing popup…`);

                timer = setTimeout(() => {
                    showPopup();
                    localStorage.setItem("emailPopupLastShown", Date.now());
                }, delay);
            }
        }

        window.addEventListener("scroll", onScroll);
        return () => {
            window.removeEventListener("scroll", onScroll);
            clearTimeout(timer);
        };
    }, [showPopup]);
}